const news3 = `## SweatText Concept Demo Released
**2025-07-15**

We're excited to announce the release of the SweatText demo! This tool will continue to be built out as the first functional tool soon. This tool, once complete, will allow trainers to send SMS reminders to clients, helping them stay on track with their workout appointments. This will help trainers keep everyone engaged and accountable.
`;

export default news3;